import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_3 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/avatars/admin.png",
  alt: "metronic"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("b", null, _toDisplayString(_ctx.email), 1)
      ]),
      _createVNode(_component_KTUserMenu)
    ]),
    _hoisted_6
  ]))
}